import { render, staticRenderFns } from "./TextShort.vue?vue&type=template&id=0e801718&"
import script from "./TextShort.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TextShort.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports